module.exports = __webpack_public_path__ + "img/black.771b33a.svg";